export default __webpack_public_path__ + "static/media/748.0794df44.png";